var _path, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumberedList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6L9 6M21 12L9 12M21 18L9 18",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 3.5,
    y: 7.5,
    fontSize: 6,
    fontFamily: "Arial, sans-serif",
    fill: "#010101",
    textAnchor: "middle"
  }, "1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 3.5,
    y: 13.5,
    fontSize: 6,
    fontFamily: "Arial, sans-serif",
    fill: "#010101",
    textAnchor: "middle"
  }, "2")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 3.5,
    y: 19.5,
    fontSize: 6,
    fontFamily: "Arial, sans-serif",
    fill: "#010101",
    textAnchor: "middle"
  }, "3")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberedList);
export default __webpack_public_path__ + "static/media/NumberedList.4a671818145794bf91dac619ada24921.svg";
export { ForwardRef as ReactComponent };